import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SuivieImportsService {
  module = environment.webService.server + environment.webService.url + environment.webService.api;

  constructor(private http: HttpClient) {}

  getAllSuivieImports(offset: number, limit: number, filtre: any | null = null, filterGenerique: any | null = null) {
    filtre = filtre || '';
    let url = this.module + '/suivi-imports';
    if (filtre != '' && filtre !== undefined && filtre !== null && !Array.isArray(filtre)) {
      url = url + '?' + `type=${filtre}`;
    } else {
      url = url + '?type=' + filtre.join('&type=');
    }
    if (filterGenerique != '' && filterGenerique !== undefined && filterGenerique !== null) {
      filterGenerique = filterGenerique.toLowerCase();
      if (filterGenerique.includes('ter')) {
        filterGenerique = 'TERMINE';
      }
      if (filterGenerique.includes('en ')) {
        filterGenerique = 'EN_COURS';
      }
      if (filterGenerique.includes('err')) {
        filterGenerique = 'ECHEC';
      }
      url = url + '&' + `filterGenerique=${filterGenerique}`;
    }
    const params = new HttpParams().set('page', offset).set('size', limit);

    return this.http.get<any>(url, { params });
  }
  getAllSuivieExport(offset: number, limit: number, filtre: any | null = null, filterGenerique: any | null = null) {
    filtre = filtre || '';
    let url = this.module + '/suivi-imports';

    url = url + '?type=' + filtre.join('&type=');
    if (filterGenerique != '' && filterGenerique !== undefined && filterGenerique !== null) {
      filterGenerique = filterGenerique.toLowerCase();
      if (filterGenerique.includes('ter')) {
        filterGenerique = 'TERMINE';
      }
      if (filterGenerique.includes('en ')) {
        filterGenerique = 'EN_COURS';
      }
      if (filterGenerique.includes('err')) {
        filterGenerique = 'ECHEC';
      }
      url = url + '&' + `filterGenerique=${filterGenerique}`;
    }
    const params = new HttpParams().set('page', offset).set('size', limit);

    return this.http.get<any>(url, { params });
  }
  getFile(fileName: string, type: string) {
    /**
     * type = IMPORT ou EXPORT
     */
    /**
     * Le résultat n'est pas forcément convertible en JSON
     */
    if (type == 'IMPORT') {
      let HTTPOptions: Object = {
        responseType: 'text'
      };
      return this.http.get<any>(this.module + `/suivi-imports/download-file/${fileName}`, HTTPOptions);
    } else {
      let HTTPOptions: Object = {
        responseType: 'blob'
      };
      // EXPORT
      return this.http.get<any>(this.module + `/suivi-imports/download-export-file/${fileName}`, HTTPOptions);
    }
  }

  /**
   *
   * @param file data du input file
   * @returns
   */
  // Fichier CSV des agents
  importAgentFile(file: any, fileName: string) {
    const fd = new FormData();
    fd.append('file', file, fileName);

    return this.http.post<any>(this.module + '/agents/import', fd, {
      /*reportProgress: true,
      observe: 'events'*/
    });
  }

  // Fichier CSV des absences agents
  importAbsenceFile(file: any, fileName: string) {
    const fd = new FormData();
    fd.append('file', file, fileName);

    return this.http.post<any>(this.module + '/agents/absences/import', fd, {
      /*reportProgress: true,
        observe: 'events'*/
    });
  }

  // Fichier CSV des données CDISation agents
  importCdisationFile(file: any, fileName: string) {
    const fd = new FormData();
    fd.append('file', file, fileName);

    return this.http.post<any>(this.module + '/agents/cdisation/import', fd, {
      /*reportProgress: true,
        observe: 'events'*/
    });
  }

  // Fichier CSV des données SNF agents
  importSnfFile(file: any, fileName: string) {
    const fd = new FormData();
    fd.append('file', file, fileName);

    return this.http.post<any>(this.module + '/agents/snf/import', fd, {
      /*reportProgress: true,
        observe: 'events'*/
    });
  }

  // Fichier CSV des données Fin de contrat agents
  importFinContratFile(file: any, fileName: string) {
    const fd = new FormData();
    fd.append('file', file, fileName);

    return this.http.post<any>(this.module + '/agents/fin-contrat/import', fd, {
      /*reportProgress: true,
        observe: 'events'*/
    });
  }

  // Fichier des organisations
  importOrganisationFile(file: any, fileName: string) {
    const fd = new FormData();
    fd.append('file', file, fileName);

    return this.http.post<any>(this.module + '/directions/import', fd, {
      /*reportProgress: true,
      observe: 'events'*/
    });
  }

  // Fichier CSV des postes
  importPosteFile(file: any, fileName: string) {
    const fd = new FormData();
    fd.append('file', file, fileName);

    return this.http.post<any>(this.module + '/postes/import', fd, {
      /*reportProgress: true,
        observe: 'events'*/
    });
  }
}
